export default __webpack_public_path__ + "static/media/meudindin.cd757d42.gif";